import React, { Component } from 'react'
import { CheckCircleFilled } from '@ant-design/icons'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Modal, Button, Input } from 'hljd'
import { observer } from 'mobx-react'
import Store from './store'
import Phone from './Phone'
import ImgCode from './ImgCode'
import SmsCode from './SmsCode'
import { isPhone } from '@hlj/hlj-utils'
import styles from './formStyle'

const FormItem = Form.Item
const formItemLayout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 13 }
}
const PASSWORD_REG_EXP = /^(?![^a-zA-Z]+$)(?!\D+$)/

@Form.create()
@observer
export default class extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()

    this.state = {
      pwdIcon: false,
      rePwdIcon: false
    }
  }

  componentDidMount() {
    this.store.checkVisible()
  }

  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.store.submit(values)
      }
    })
  }

  validatorPhone = (rule, value, callback) => {
    if (!value) {
      callback('请输入手机号码')
    } else if (!isPhone(value)) {
      callback('请输入正确的手机号码')
    } else {
      callback()
    }
  }

  validatorPassword = (rule, value, callback) => {
    if (!value) {
      this.setState({ pwdIcon: false })
      callback('请输入密码')
    } else if (
      value.length < 8 ||
      value.length > 20 ||
      !PASSWORD_REG_EXP.test(value)
    ) {
      this.setState({ pwdIcon: false })
      callback('密码要求必须包含字母和数字，长度8-20位')
    } else {
      callback()
      this.setState({ pwdIcon: true })
    }
  }

  validatorRePwd = (rule, value, callback) => {
    const form = this.props.form
    if (!value) {
      callback('请确认密码')
      this.setState({ rePwdIcon: false })
    } else if (value && value !== form.getFieldValue('password')) {
      callback('请保持两次输入的密码一致')
      this.setState({ rePwdIcon: false })
    } else {
      callback()
      this.setState({ rePwdIcon: true })
    }
  }

  render() {
    const {
      oneSubStoreVisible,
      moreSubStoreVisible,
      name,
      canLogout,
      count
    } = this.store

    const {
      setFieldsValue,
      getFieldDecorator,
      validateFields,
      getFieldsValue
    } = this.props.form

    const { pwdIcon, rePwdIcon } = this.state

    return (
      <>
        <Modal
          title="子商家解绑"
          closable={false}
          visible={oneSubStoreVisible}
          footer={[
            <Button
              type="primary"
              disabled={canLogout}
              onClick={this.store.reLogin}
            >
              {!canLogout ? '重新登录' : `${count}S`}
            </Button>
          ]}
        >
          <p>
            亲爱的商家，由于四大金刚类目业务升级，将不再支持父子账号功能，您的父账号将被删除，旗下的子账号“{
              name
            }”将解除绑定，您可使用原父账号的账号密码登录子账号
          </p>
        </Modal>

        <Modal
          title="子商家解绑"
          closable={false}
          visible={moreSubStoreVisible}
          footer={[
            <Button type="primary" onClick={this.handleSubmit}>
              确定
            </Button>
          ]}
        >
          <p>
            亲爱的商家，由于四大金刚类目业务升级，将不再支持父子账号功能，当前您的账号“{
              name
            }”将解除绑定，请为其设置新的登录账号密码
          </p>

          <div className={styles.box}>
            <FormItem label="登录手机号" {...formItemLayout}>
              {getFieldDecorator('contact_phone', {
                rules: [
                  {
                    validator: this.validatorPhone
                  }
                ],
                validateTrigger: ['onBlur']
              })(
                <Phone
                  setFieldsValue={setFieldsValue}
                  validateFields={validateFields}
                />
              )}
            </FormItem>

            <FormItem label="图形验证码" {...formItemLayout}>
              {getFieldDecorator('image_code', {
                rules: [
                  {
                    required: true,
                    message: '请输入图形验证码'
                  }
                ]
              })(<ImgCode setFieldsValue={setFieldsValue} />)}
            </FormItem>

            <FormItem label="短信验证码" {...formItemLayout}>
              {getFieldDecorator('code', {
                rules: [
                  {
                    required: true,
                    message: '请输入短信验证码'
                  }
                ]
              })(
                <SmsCode
                  setFieldsValue={setFieldsValue}
                  getFieldsValue={getFieldsValue}
                />
              )}
            </FormItem>

            <FormItem label="密码" {...formItemLayout}>
              {getFieldDecorator('password', {
                rules: [
                  {
                    validator: this.validatorPassword
                  }
                ]
              })(
                <Input
                  style={{ width: 250 }}
                  type="password"
                  autoComplete="new-password"
                />
              )}
              <CheckCircleFilled
                className={styles.rightIcon}
                style={{ display: pwdIcon ? 'inline-block' : 'none' }}
              />
            </FormItem>

            <FormItem label="确认密码" {...formItemLayout}>
              {getFieldDecorator('re_password', {
                rules: [
                  {
                    validator: this.validatorRePwd
                  }
                ]
              })(<Input style={{ width: 250 }} type="password" />)}
              <CheckCircleFilled
                className={styles.rightIcon}
                style={{ display: rePwdIcon ? 'inline-block' : 'none' }}
              />
            </FormItem>
          </div>
        </Modal>
      </>
    )
  }
}
